import React, { useState, useEffect } from 'react';

const APP_STORE_URL = 'https://apps.apple.com/ca/app/litrlly-app/id6758524303';
const BANNER_DISMISSED_KEY = 'ios_app_banner_dismissed_v2';

const IOSAppBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if banner was previously dismissed
    const wasDismissed = localStorage.getItem(BANNER_DISMISSED_KEY);

    // Check if running as standalone (already installed as PWA)
    const isStandalone = (window.navigator as any).standalone === true;

    // Show banner for all users, unless dismissed or standalone
    if (!wasDismissed && !isStandalone) {
      // Small delay to not interfere with page load
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up safe-area-bottom">
      {/* iOS-style Smart App Banner */}
      <div className="bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl border-t border-gray-200/50 dark:border-slate-700/50 px-4 py-3">
        <div className="max-w-lg mx-auto flex items-center gap-3">
          {/* Close button - iOS style */}
          <button
            onClick={handleDismiss}
            className="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 p-1 -ml-1 flex-shrink-0"
            aria-label="Close"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* App icon - iOS rounded rect style */}
          <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-[12px] flex items-center justify-center flex-shrink-0 shadow-sm">
            <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
            </svg>
          </div>

          {/* App info */}
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-gray-900 dark:text-white text-[15px] leading-tight">Litrlly</p>
            <p className="text-[13px] text-gray-500 dark:text-gray-400 leading-tight">Pronunciation Practice</p>
            <p className="text-[11px] text-gray-400 dark:text-gray-500 leading-tight mt-0.5">FREE - App Store</p>
          </div>

          {/* GET button - iOS App Store style */}
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-500 hover:bg-blue-600 active:bg-blue-700 text-white px-5 py-1.5 rounded-full text-[15px] font-semibold transition-colors flex-shrink-0 shadow-sm"
          >
            GET
          </a>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .safe-area-bottom {
          padding-bottom: env(safe-area-inset-bottom, 0);
        }
      `}</style>
    </div>
  );
};

export default IOSAppBanner;
